import { GridList } from '@sleepstation/components'
import { LAYOUT_SPACING, SIZE } from '@sleepstation/const'
import { renderList, replaceTokens } from '@sleepstation/utils'
import PropTypes from 'prop-types'
import { when } from 'ramda'
import { isNotNil } from 'ramda-adjunct'
import React from 'react'
import TestimonialSimple from '../TestimonialSimple'

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const templateFuncOrUndefined = when(isNotNil, replaceTokens)

const renderTestimonials = (subtitleTemplateDefault, testimonials) =>
  renderList((testimonial) => {
    const subtitleTemplate =
      testimonial.subtitleTemplate || subtitleTemplateDefault

    return (
      <TestimonialSimple
        testimonial={testimonial}
        toSubtitle={templateFuncOrUndefined(subtitleTemplate)}
        size={SIZE.LARGE}
      />
    )
  }, testimonials)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const TestimonialSimpleList = ({ testimonials, subtitleTemplate }) => (
  <GridList
    columns={[1, 1, 2]}
    spacing={[
      LAYOUT_SPACING.XX_LARGE,
      LAYOUT_SPACING.XX_LARGE,
      [4, LAYOUT_SPACING.XX_LARGE],
    ]}
  >
    {renderTestimonials(subtitleTemplate, testimonials)}
  </GridList>
)

TestimonialSimpleList.propTypes = {
  testimonials: PropTypes.arrayOf(PropTypes.object).isRequired,
  subtitleTemplate: PropTypes.string,
}

TestimonialSimpleList.defaultProps = {
  subtitleTemplate: undefined,
}

export default TestimonialSimpleList
